export default {
    fillToPageGetMult(state,data){
        console.log(state)
        console.log(data)
        // if(data.meta.pic && data.meta.pic == ''){
        //     data.meta.pic = 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png'
        // }
        data=Object.assign({},state.data,data)
        state.data=data
    }
}
